import { useTranslation } from 'react-i18next';
import { Flex } from '@chakra-ui/react';

import { ExternalLink } from '@izimi/components';
import { getExternalLinks } from 'util/links';

export const Footer = () => {
  const {
    t,
    i18n: { language },
  } = useTranslation('naban');

  return (
    <Flex justifyContent='end' my={1.5} px={5} w='100%'>
      <ExternalLink fontSize='.875rem' href={getExternalLinks({ lang: language }).privacyPolicy}>
        {t('footer.privacyPolicy.label')}
      </ExternalLink>
    </Flex>
  );
};
